import * as Yup from 'yup';
import { ORDERS } from '../../../const';
import { IModalOrderCustomer, IModalOrderFormikValues } from '../components/ModalOrder/interfaces';

export const PAY_LINK_TTL = '03:00:00'
export const PAY_LINK_TTL_EMPTY = '00:00:00'

export enum TYPES_PIPE_OR_WAVE  {
  WAVE =  'WAVE',
  PIPE =  'PIPE',
} 

export const NAME_PIPE_OR_WAVE = {
  [TYPES_PIPE_OR_WAVE.WAVE]: 'Волна',
  [TYPES_PIPE_OR_WAVE.PIPE]: 'Труба',
};
export enum TYPES_STATUS {
  NEW_ORDER,
  CANCEL,
  IN_WORK,
  PAY_LOAD,
  PAY_LOCAL,
  PAY_SUCCESS,
  PAY_PARTLY,
  PAY_ERROR,
  CLOSE,
  PAY_ONLINE
}

export enum TYPES_SERVICES {
  OTHER,
  MINUTE_DEPOSIT_SERVICE_TYPE,
  HOTEL_BOOKING,
  AERO_TUBE_CERTIFICATE_SERVICE_TYPE,
  AERO_TUBE_SERVICE_TYPE,
  WAVE_SERVICE_TYPE,
  RENT,
  WAVE_CERTIFICATE_SERVICE_TYPE,
  REFILL,
  MONEY_DEPOSIT_SERVICE_TYPE,
  ALL
}

export enum PAY_ORDER_TYPES_STATUS {
  PAY_LOAD,
  PAY_PARTLY,
  PAY_SUCCESS,
  CANCEL,
  ALL
}

export enum TYPES_TASK {
  'Пропущенный звонок',
  'Обратный звонок',
  'E-mail',
  'Напоминание',
  'Звонок',
  'Задача руководства',
  'Заявка',
  'Контрагент',
  'Прочее',
  'Лендинг',
  'Все',
}
export enum TYPES_SCORE {
  PAY_LOAD,
  PAY_PARTLY,
  PAY_SUCCESS,
  CANCEL
}

export enum CREATE_USER_RES_TYPE {
  EMAIL,
  SMS
}

export const NAME_STATUS_SCORE: any = {
  PAY_LOAD: {
    title: 'Ждем оплату',
    class: 'pay-local'
  },
  PAY_SUCCESS: {
    title: 'Оплачен ',
    class: 'pay-success'
  },
  CANCEL: {
    title: 'Отменен',
    class: 'cancel'
  },
  PAY_PARTLY: {
    title: 'Частично оплачен',
    class: 'pay-partly'
  },
};
export const NAME_STATUS: any = {
  NEW_ORDER: {
    title: 'Новая заявка',
    class: 'new-order'
  },
  PAY_SUCCESS: {
    title: 'Оплачен ',
    class: 'pay-success'
  },
  CLOSE: {
    title: 'Закрыта',
    class: 'close'
  },
  IN_WORK: {
    title: 'В работе ',
    class: 'in-work'
  },
  PAY_ERROR: {
    title: 'Ошибка оплаты',
    class: 'pay-error'
  },
  PAY_LOAD: {
    title: 'Ждем оплату',
    class: 'pay-load'
  },
  PAY_LOCAL: {
    title: 'Оплата на месте ',
    class: 'pay-local'
  },
  CANCEL: {
    title: 'Отказ',
    class: 'cancel'
  },
  PAY_PARTLY: {
    title: 'Частично оплачен',
    class: 'pay-partly'
  },
  PAY_ONLINE: {
    title: 'Оплачен онлайн',
    class: 'pay-success'
  }
};

export const TITLES: Record<string, any> = {
  wave: 'Запись на волну',
  pipe: 'Запись на трубу',
}

export const TYPE_STATUS = ['Оплачен онлайн', 'Оплатил', 'Закрыта'];

export const customSelectUserStyles = {
  control: (provided: Record<string, any>) => ({
    ...provided,
    maxWidth: 390,
    minWidth: 150,
    border: 'none',
    cursor: 'pointer',
    margin: 0,
    fontSize: 16,
    boxShadow: 'none',
    borderRadius: '32px',
  }),
  ValueContainer: (provided: Record<string, any>) => ({
    ...provided,
    padding: 0,
    gap: 5
  }),
  menu: (provided: Record<string, any>) => ({
    ...provided,
    zIndex: 11
  }),
  container: (provided: Record<string, any>) => ({
    ...provided,
    width: '100%'
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
}
export const customMultiSelectUserStyles = {
  valueContainer: (provided: Record<string, any>) => ({
    ...provided,
    maxHeight: 200,
    minHeight: 48,
    maxWidth: 390,
    minWidth: 150,
    overflow: 'auto',
    gap: 5
  }),
  // multiValue: (provided: Record<string, any>) => ({
  //   ...provided,
  //   borderRadius: 28,
  //   backgroundColor: '#F2F6F8',
  //   // padding: 5,
  //   'div:first-of-type': {
  //     '@media screen and (max-width:570px)':{
  //       display:'block'
  //     }
  //   }
  // }),
  multiValue: () => ({
    borderRadius: 28,
    backgroundColor: '#F2F6F8',
    display: 'flex',
    padding: '0 10px'
  }),
  multiValueRemove: (provided: Record<string, any>) => ({
    ...provided,
    cursor: 'pointer',
    ':hover': {
      color: 'blue',
    },
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
  control: (provided: Record<string, any>) => ({
    ...provided,
    width: 326,
    '@media screen and (max-width:810px)': {
      width: '100%'
    }
  }),
}

export const defaultStyles = {
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
  control: (provided: Record<string, any>) => ({
    ...provided,
    minHeight: 48,
    width: '100%'
  }),
  container: (provided: Record<string, any>) => ({
    ...provided,
    width: '100%'
  }),
  menu: (provided: Record<string, any>) => ({
    ...provided,
    // maxHeight:150,
    // overflow:'auto'
  }),
}

export const customStatusSelect = {
  control: (provided: Record<string, any>) => ({
    ...provided,
    maxWidth: 390,
    // minWidth: 150,
    border: 'none',
    cursor: 'pointer',
    margin: 0,
    fontSize: 16,
    boxShadow: 'none',
    borderRadius: '32px'
  }),
  valueContainer: (provided: Record<string, any>) => ({
    ...provided,
    maxHeight: 200,
    overflow: 'auto',
    padding: 3
  }),
  multiValue: (provided: Record<string, any>) => ({
    ...provided,
    borderRadius: 28,
    backgroundColor: '#F2F6F8',
    // padding: 5,
    'div:first-of-type': {
      '@media screen and (max-width:570px)': {
        display: 'block'
      }
    }
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
  menu: (provided: Record<string, any>) => ({
    ...provided,
    margin: 0,
    minWidth: 150,
    zIndex: 13,
    width: 'auto',
  }),
  container: (provided: Record<string, any>) => ({
    ...provided,
    maxWidth: 300,
    width: '100%'
  }),
}

export const stylesStatusTaskSelect = {
  control: (provided: Record<string, any>) => ({
    ...provided,
    display: 'flex',
    overflow: 'hidden',
    width: '270px',
    borderRadius: '15px',
    border: 'none',
    boxShadow: 'none',
  }),
  multiValue: (provided: Record<string, any>, state: any) => ({
    ...provided,
    maxWidth: '190px',
    overflow: 'hidden',
    borderRadius: '10px',
    backgroundColor: '#d6e4ff',
    minWidth: state.data === state.selectProps.value[0] ? 'fit-content' : '60px',
  }),
  multiValueLabel: (provided: Record<string, any>) => ({
    ...provided,
    maxWidth: '190px',
  
  }),
  valueContainer: (provided: Record<string, any>) => ({
    ...provided,
    maxWidth: '200px',
    height: '26px',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    flexFlow: 'nowrap'
  }),
  menu: (provided: Record<string, any>) => ({
    ...provided,
    margin: 0,
    width: 250,
    zIndex: 13,
  }),
  placeholder: (provided: Record<string, any>) => ({
    ...provided,
    fontSize: 16,
  }),
}

export const discountOptions = [
  { value: 0, label: 'Нет' },
  { value: 1, label: 'Да' },
]

export const saleSourceOptions = [
  { value: 0, label: 'Визит' },
  { value: 1, label: 'Звонок' },
  { value: 2, label: 'Заказ звонка' },
  { value: 3, label: 'Почта' },
  { value: 4, label: 'Онлайн' },
  { value: 5, label: 'Instagram' },
  { value: 6, label: 'Facebook' },
  { value: 7, label: 'Вконтакте' },
  { value: 8, label: 'YouTube' },
]

export const statusOptions = [
  { value: TYPES_STATUS.CANCEL, label: 'Отказ' },
  { value: TYPES_STATUS.PAY_LOAD, label: 'Ждем оплату' },
  { value: TYPES_STATUS.PAY_LOCAL, label: 'Оплата на месте' },
  { value: TYPES_STATUS.PAY_SUCCESS, label: 'Оплачен' },
  { value: TYPES_STATUS.PAY_PARTLY, label: 'Частично оплачен' },
  { value: TYPES_STATUS.CLOSE, label: 'Закрыта' },
  { value: TYPES_STATUS.PAY_ONLINE, label: 'Все' },
]

export const statusOptions2 = [
  { value: TYPES_STATUS.PAY_LOAD, label: 'Ждем оплату' },
  { value: TYPES_STATUS.PAY_LOCAL, label: 'Оплата на месте' },
  { value: TYPES_STATUS.PAY_SUCCESS, label: 'Оплачен' },
  { value: TYPES_STATUS.PAY_PARTLY, label: 'Частично оплачен' },
  { value: TYPES_STATUS.CLOSE, label: 'Закрыта' },
  { value: TYPES_STATUS.PAY_ONLINE, label: 'Все' },
]

export const statusPayOrderOptions = [
  { value: PAY_ORDER_TYPES_STATUS.PAY_LOAD, label: 'Ждем оплату' },
  { value: PAY_ORDER_TYPES_STATUS.PAY_PARTLY, label: 'Частично оплачен' },
  { value: PAY_ORDER_TYPES_STATUS.PAY_SUCCESS, label: 'Оплачен' },
  { value: PAY_ORDER_TYPES_STATUS.CANCEL, label: 'Отменен' },
  { value: PAY_ORDER_TYPES_STATUS.ALL, label: 'Все' }
];

export const serviceOptions = [
  {
    value: [TYPES_SERVICES.AERO_TUBE_SERVICE_TYPE, TYPES_SERVICES.WAVE_SERVICE_TYPE].join(','),
    label: 'Труба и Волна'
  },
  {
    value: TYPES_SERVICES.OTHER,
    label: 'Другое'
  },
  {
    value: [
      TYPES_SERVICES.MINUTE_DEPOSIT_SERVICE_TYPE,
      TYPES_SERVICES.MONEY_DEPOSIT_SERVICE_TYPE
    ].join(','),
    label: 'Депозиты'
  },
  {
    value: [
      TYPES_SERVICES.AERO_TUBE_CERTIFICATE_SERVICE_TYPE,
      TYPES_SERVICES.WAVE_CERTIFICATE_SERVICE_TYPE
    ].join(','),
    label: 'Сертификаты'
  },
  {
    value: TYPES_SERVICES.ALL,
    label: 'Все'
  }
];

const requiredText = 'Это обязательное поле';

export const validationSchemaOrders = Yup.object().shape({
  customer: Yup.object().required(),
});

export const TRANSLATE_LABELS_ERR: Record<string, any> = {
  customer: 'Контрагент.',
  start_at: 'Дата начала заявки.',
  tariff: {
    id: 'Индификатор тарифа.',
    title: 'Название тарифа.',
    is_child: 'Флаг дети.',
    price: 'Цена тарифа.',
  },
  tariff_rate: 'Тарифная ставка',
  participants: 'Участники.',
  fly_session_minutes: 'Сессия.',
  session_minutes: 'Время.',
  non_field_errors: 'Тариф.',
  source: 'Источник:',
  price: 'Цена.',
  count_party: 'Кол-во участников.',
  price_paid: 'Оплачено.',
  comment: 'Комментарий.',
  is_pay_here: 'Статус оплаты.',
  is_arrived: 'Статус прибытия.',
  phone: 'Телефон.',
  email: 'E-mail.'
}

export enum TYPES_ACTIONS_ORDERS {
  TRANSFER,
  CHECK_DATE
}

export const NAME_STATUS_API_ORDER = {
  DELETE: {
    PENDING: 'Идет удаление заявки...',
    SUCCESS: 'Заявка успешно удалена!',
    ERROR: 'Ошибка удаления заявки!',
  },
  UPDATE: {
    CLOSE: {
      PENDING: 'Идет обновление заявки...',
      SUCCESS: 'Заявка успешно закрыта!',
      ERROR: 'Ошибка закрытия заявки!',
    },
    TRANSFER: {
      PENDING: 'Идет перенос заявки...',
      SUCCESS: 'Заявка успешно перенесена!',
      ERROR: 'Ошибка переноса заявки!',
      ERROR_500: 'Ошибка сервера. Заявки не созданы!'
    },
    USER: {
      PENDING: 'Идет обновление пользователя...',
      SUCCESS: 'Пользователь успешно обновлен!',
      ERROR: 'Ошибка обновление пользователя!',
      ERROR_500: 'Ошибка сервера. Пользователь не обновлен! Код ошибки:'
    },
    PENDING: 'Идет обновление заявки...',
    SUCCESS: 'Заявка успешно обновлена!',
    ERROR: 'Ошибка обновления заявки!',
    ERROR_500: 'Ошибка сервера. Заявка не обновлена!'
  },
  CREATE: {
    ORDERS: {
      PENDING: 'Идет создание заявок...',
      SUCCESS: 'Заявки успешно созданы!',
      ERROR: 'Ошибка создания заявок!',
      ERROR_500: 'Ошибка сервера. Заявки не созданы!'
    },
    ORDER: {
      PENDING: 'Идет создание заявки...',
      SUCCESS: 'Заявка успешно создана!',
      ERROR: 'Ошибка создания заявки!',
      ERROR_500: 'Ошибка сервера. Заявка не создана!'
    },
    USER: {
      PENDING: 'Идет создание пользователя...',
      SUCCESS: 'Пользователь успешно создан!',
      ERROR: 'Ошибка создания пользователя!',
      ERROR_500: 'Ошибка сервера. Пользователь не создан! Код ошибки: '
    },
    TASK: {
      PENDING: 'Идет создание задачи...',
      SUCCESS: 'Задача успешно создана!',
      ERROR: 'Ошибка создания задачи!',
      ERROR_500: 'Ошибка сервера. Задача не создана! Код ошибки: '
    }
  },
  PROMOCODE: {
    PENDING: 'Загружаем...',
    SUCCESS: 'Промокод успешно принят!',
    ERROR_REQ: 'Ошибка запроса!',
    ERROR: 'Промокод не активен или не существует!',
    ERROR_NAME: 'Введите промокод!',
    ERROR_TARIFF: 'Необходимо выбрать тариф!',
  },
  MANUAL_STOCK: {
    PENDING: 'Идет проверка акции...',
    SUCCESS: 'Акция успешно применена!',
    ERROR: 'Ошибка! ',
    ERROR_500: 'Ошибка сервера. Код ошибки: ',
  },
  LOGIN: {
    ERROR_500: 'Ошибка сервера. Код ошибки',
    ERROR: 'Ошибка! Невозможно войти с предоставленными учетными данными.'
  },
  PAYMENT: {
    PENDING: 'Идет процесс оплаты...',
    SUCCESS: 'Оплата успешно прошла!',
    SUCCESS_URL: 'Ссылка успешно получена.',
    ERROR_URL: 'Ошибка получения ссылки.',
    ERROR: 'Ошибка оплаты!',
    ERROR_500: 'Ошибка сервера. Оплата не прошла! Код ошибки: '
  },
  PAYMENT_ONLINE: {
    PENDING: 'Идет процесс получения ссылки на оплату...',
    SUCCESS: 'Ссылка успешно получена!',
    ERROR: 'Ошибка получения ссылки!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
  PAYMENT_DEPOSIT_LOCAL: {
    PENDING: 'Идет процесс формирования услуги...',
    SUCCESS: 'Услуга успешно сформирована',
    ERROR: ': Ошибка формирования услуги!',
    ERROR_500: 'Ошибка формирования услуги! Код ошибки: '
  },
  CONTRACTS: {
    PENDING: 'Идет процесс создания анкет...',
    SUCCESS: 'Успешно!',
    ERROR: 'Ошибка создания анкет(ы)!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
  RESPONSE_TASK: {
    PENDING: 'Идет процесс отправки...',
    SUCCESS: 'Сообщение успешно отправлено!',
    ERROR: 'Ошибка отправки!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
  RETURN_ORDERS: {
    PENDING: 'Идет процесс возврата оплаты...',
    SUCCESS: 'Успешно!',
    ERROR: 'Ошибка возврата!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
  ACTIVATE_CERTIFICATE: {
    PENDING: 'Идет процесс активации сертификата...',
    SUCCESS: 'Успешно активирован!',
    ERROR: 'Ошибка активации сертификата!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
  PRINT_CERTIFICATES: {
    PENDING: 'Идет процесс печати сертифкатов...',
    SUCCESS: 'Успешно!',
    ERROR: 'Ошибка печати сертифкатов!',
    ERROR_500: 'Ошибка сервера! Код ошибки: ',
    ERROR_ITEM: 'Анкет для подписи нет'
  },
  LOAD_ORDERS: {
    PENDING: 'Идет процесс выгрузки...',
    SUCCESS: 'Успешно!',
    ERROR: 'Ошибка выгрузки заявок!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
  RETURN: {
    PENDING: 'Идет процесс возврата...',
    SUCCESS: 'Успешно!',
    ERROR: 'Ошибка возврата!',
    ERROR_500: 'Ошибка сервера! Код ошибки: '
  },
}

export const validationSchemaPaymentCash = Yup.object().shape({
  amount: Yup.string().required(requiredText)
});

export enum PAYMENT_TYPE {
  IN_CASH,
  CARD,
  FROM_DEPOSIT_RUBLES,
  FROM_DEPOSIT_MINUTES,
  ONLINE,
  NOT_CHOICE,
  CERTIFICATE,
  THIRD_CERTIFICATE,
  STOCK,
  WITHOUT_CASH,
  TRANSFER,
  DEPOSITS
}

export const PAYMENT_METHOD = [
  {
    id: PAYMENT_TYPE.IN_CASH,
    name: 'IN_CASH',
    title: 'Наличными',
  },
  {
    id: PAYMENT_TYPE.CARD,
    name: 'CARD',
    title: 'Картой'
  },
  {
    id: PAYMENT_TYPE.FROM_DEPOSIT_RUBLES,
    name: 'FROM_DEPOSIT_RUBLES',
    title: 'Денежный депозит'
  },
  {
    id: PAYMENT_TYPE.FROM_DEPOSIT_MINUTES,
    name: 'FROM_DEPOSIT_MINUTES',
    title: 'Ресурсный депозит'
  },
  {
    id: PAYMENT_TYPE.ONLINE,
    name: 'ONLINE',
    title: 'Онлайн'
  },
  {
    id: PAYMENT_TYPE.CERTIFICATE,
    name: 'CERTIFICATE',
    title: 'Сертификат'
  },
  {
    id: PAYMENT_TYPE.TRANSFER,
    name: 'TRANSFER',
    title: 'Банковский перевод'
  }
]

export const TYPE_USER_SPORTSMAN: any = {
  [ORDERS.PIPE]: 'tube_user_type',
  [ORDERS.WAVE]: 'wave_user_type'
}

export const RANGE_TYPE = {
  day: 'day',
  week: 'week',
}

export const PAYMENT_ITEMS = [
  {
    id: PAYMENT_TYPE.IN_CASH,
    title: 'Наличными',
    flag: true
  },
  {
    id: PAYMENT_TYPE.CARD,
    title: 'Картой',
    flag: true
  },
  {
    id: PAYMENT_TYPE.TRANSFER,
    title: 'Банковский перевод',
    flag: true
  },
  {
    id: PAYMENT_TYPE.CERTIFICATE,
    title: 'Сертификаты',
    flag: true
  },
  {
    id: PAYMENT_TYPE.DEPOSITS,
    title: 'Депозит',
    flag: true
  }
]

export const PAYMENT_TYPE_TITLE: any = {
  [PAYMENT_TYPE.IN_CASH]: {
    title: 'Наличными'
  },
  [PAYMENT_TYPE.CARD]: {
    title: 'Картой'
  },
  [PAYMENT_TYPE.TRANSFER]: {
    title: 'Банковский перевод'
  },
  [PAYMENT_TYPE.CERTIFICATE]: {
    title: 'Сертификаты'
  },
  [PAYMENT_TYPE.DEPOSITS]: {
    title: 'Депозит'
  },
  [PAYMENT_TYPE.FROM_DEPOSIT_MINUTES]: {
    title: 'Депозит'
  }
}

export const PAYMENT_DEPOSITS_ITEMS = [
  {
    id: PAYMENT_TYPE.IN_CASH,
    title: 'Наличными'
  },
  {
    id: PAYMENT_TYPE.CARD,
    title: 'Картой'
  },
  {
    id: PAYMENT_TYPE.TRANSFER,
    title: 'Банковский перевод'
  },
  {
    id: PAYMENT_TYPE.FROM_DEPOSIT_RUBLES,
    title: 'Денежным депозитом'
  }
]

export const ITEMS_BLOCK_PAY_HERE: any = {
  [PAYMENT_TYPE.IN_CASH]: {
    name: 'cash',
    type: PAYMENT_TYPE.IN_CASH,
    title: 'Наличными',
    amount_title: 'cash_amount',
    description_title: 'cash_description'
  },
  [PAYMENT_TYPE.CERTIFICATE]: {
    name: 'cash',
    type: PAYMENT_TYPE.CERTIFICATE,
    title: 'Сертификат',
    amount_title: 'certificate_amount',
    description_title: 'certificate_description'
  },
  [PAYMENT_TYPE.CARD]: {
    name: 'card',
    type: PAYMENT_TYPE.CARD,
    title: 'Картой',
    amount_title: 'card_amount',
    description_title: 'card_description'
  },
  [PAYMENT_TYPE.TRANSFER]: {
    name: 'transfer',
    type: PAYMENT_TYPE.TRANSFER,
    title: 'Банковский перевод',
    amount_title: 'transfer_amount',
    description_title: 'transfer_description'
  },
  [PAYMENT_TYPE.DEPOSITS]: {
    name: 'transfer',
    type: PAYMENT_TYPE.DEPOSITS,
    title: 'Депозит',
  },
  [PAYMENT_TYPE.FROM_DEPOSIT_MINUTES]: {
    name: 'transfer',
    type: PAYMENT_TYPE.DEPOSITS,
    title: 'Депозит',
  },
  [PAYMENT_TYPE.FROM_DEPOSIT_RUBLES]: {
    name: 'deposit',
    type: PAYMENT_TYPE.FROM_DEPOSIT_RUBLES,
    title: 'Денежный депозит',
  }
}

export const NullableDefaultValue: IModalOrderFormikValues = {
  minutes: { value: 0, label: '0 мин.' },
  count_party: { value: 0, label: '0' },
  price_paid: '0.00',
  source: undefined,
  tariff: {
    value: null, label: null, tariff_rates: [], is_for_sportsman: false,
    id: 0,
    title: '',
    is_child: false
  },
  base_price: '0.00',
  price: '0.00',
  comment: '',
  tariff_rate: {
    price: '0.00',
    strikeout_price: null,
    count_people: 0,
    minutes: 0,
    id: 0,
    rate_name: '',
    discount: null,
    is_child: false,
    tariff: '',
    tariff_type_user: '',
    date_start_at: null,
    date_end_at: null,
    description: '',
    short_description: ''
  },
  is_pay_here: true,
  is_arrived: false,
  session_minutes: 2.5,
  discount: false,
  promo_code: null,
  status: null,
  number: null,
  id: null,
  multiRates: [],
  tariff_rates: [],
  tariff_rate_multi: null,
  is_children: false,
  start_at: null,
  sessionTimeoutSecs: 0,
  is_automatic_stock: true,
  price_stock: '0.00',
  stock: undefined,
  payment_url: '',
  manual_stock: null,
  pay_order: null,
  stock_name: null,
  side: null,
  user_type_slug: null,
  author: null,
  created_at: null,
  is_sport: false,
  customer: {} as IModalOrderCustomer ,
  participants: []
}

export const DEPOSIT_PAYMENT_TITLE = {
  MONEY: 'Денежный',
  RESOURCE : 'Ресурсный' 
}